'use client';

import { useWorkspace } from '@/contexts/WorkspaceProvider';
import { useRouter, usePathname } from 'next/navigation';
import { useEffect } from 'react';

// Routes a viewer is allowed to visit. Everything else redirects to /signals.
// Personal settings (/settings) stays accessible so viewers can manage their profile.
const VIEWER_ALLOWED_PREFIXES = ['/signals', '/settings', '/notifications'];

/**
 * Redirects viewer-role users away from routes they cannot access (#2694).
 * Renders nothing — side-effect only.
 */
const ViewerRouteGuard: React.FC = () => {
  const workspaceContext = useWorkspace();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!workspaceContext?.isViewer) return;
    if (!pathname) return;

    const allowed = VIEWER_ALLOWED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
    if (!allowed) {
      router.replace('/signals');
    }
  }, [workspaceContext?.isViewer, pathname, router]);

  return null;
};

export default ViewerRouteGuard;
